import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "../Style/Hero.css";
import bannerImage from "../Assets/Banner2.png";
import { useLanguage } from "../Context/Languagecontext";

const Hero = () => {
  const heroRef = useRef(null);
  const { t, lang } = useLanguage();
  const h = t.hero;

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    // Force class immediately and via rAF as fallback
    el.classList.add("hero--loaded");
    requestAnimationFrame(() => {
      el.classList.add("hero--loaded");
    });
  }, [lang]); // re-run when lang changes

  return (
    <section
  className={`hero hero--loaded ${lang === "ta" ? "hero--ta" : ""}`}
  ref={heroRef}
>
      {/* ── Background Image Layer ── */}
      <div className="hero__bg-wrap">
        <div
          className="hero__bg"
          style={{ backgroundImage: `url(${bannerImage})` }}
        />
        <div className="hero__overlay hero__overlay--dark" />
        <div className="hero__overlay hero__overlay--vignette" />
        <div className="hero__overlay hero__overlay--gradient" />
      </div>

      {/* ── Side Rules ── */}
      <div className="hero__side-rule hero__side-rule--left">
        <span className="hero__side-text">{h.established}</span>
      </div>
      <div className="hero__side-rule hero__side-rule--right">
        <span className="hero__side-text">{h.groupName}</span>
      </div>

      {/* ── Content — sits below face ── */}
      <div className="hero__content">
        {/* Ornament */}
        <div className="hero__ornament">
          <span className="hero__ornament-line" />
          <span className="hero__ornament-diamond" />
          <span className="hero__ornament-line" />
        </div>

        {/* Honorific */}
        <p className="hero__honorific">{h.honorific}</p>

        {/* Title — single line, italic on surname */}
        <h1 className="hero__title">
          {h.namePrefix} <em>{h.nameSurname}</em>
        </h1>

        {/* Roles */}
        <div className="hero__roles">
          <span className="hero__role">{h.role1}</span>
          <span className="hero__role-sep">·</span>
          <span className="hero__role">{h.role2}</span>
          <span className="hero__role-sep">·</span>
          <span className="hero__role">{h.role3}</span>
        </div>

        {/* Divider */}
        <div className="hero__divider">
          <span className="hero__divider-line" />
          <span className="hero__divider-icon">✦</span>
          <span className="hero__divider-line" />
        </div>

        {/* Description — 2 lines via CSS clamp */}
        <p className="hero__description">{h.description}</p>

        {/* CTA */}
        <div className="hero__cta-wrap">
          <Link to="/about" className="hero__cta">
            <span>{h.cta}</span>
            <svg
              className="hero__cta-arrow"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path
                d="M5 12h14M13 6l6 6-6 6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;